import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import "rxjs/Rx";
import { Subject }    from 'rxjs/Subject';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AuthService } from "../auth.service";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";

import { SharedModule, NumPipe, UtilsService } from "../shared/shared.module";
import * as _ from "lodash";
import * as XLSX from 'xlsx';
import * as JSZip from "jszip";
import { saveAs } from 'file-saver/FileSaver';


declare let swal:any;

@Component({
  selector: 'app-list-campaign',
  templateUrl: './list-campaign.component.html'
})
export class ListCampaignComponent implements OnInit {

  page: number = 1;
  totalPage: number = 1;
  search: string = "";
  limit: number = 10;
  sortBy: any = ['id'];
  revert: boolean = false;
  txtQueryChanged: Subject<string> = new Subject<string>();
  isLoading: boolean = false;

  errors = {};
  campaigns:any = null;

  possibleStatus: any = [
    {value: '', text: 'Toutes les campagnes'},
    {value: 'IN_COMING', text: 'Campagnes à venir'},
    {value: 'IN_PROGRESS', text: 'Campagnes en cours'},
    {value: 'DONE', text: 'Campagnes clôturées'}
  ];

  selectedStatus: string = '';

  constructor(
    private numPipe: NumPipe,
    public authService: AuthService,
    private http: HttpClient,
    private utilsService: UtilsService,
    private router: Router,
    private route: ActivatedRoute,
    public utils: UtilsService
  ) { }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      else
        this.utilsService.scrollTop();
    });

    this.route.queryParamMap.subscribe(query => {
      if (query['params'].status)
        this.selectedStatus = query['params'].status;
    });

    this.authService.getSession();

    this.txtQueryChanged
	  .debounceTime(500) // wait x sec after the last event before emitting last event
	  .distinctUntilChanged() // only emit if value is different from previous value
	  .subscribe(model => {
      this.search = model;
      this.page = 1;
      this.getCampaigns();
    });
    this.getCampaigns();
  }


  getCampaigns(resetPage = false) {
    this.isLoading = true;
    this.errors = {};

    if (resetPage == true)
      this.page = 1;

    var query = "?search=" + this.search + "&limit=" + this.limit + "&page=" + this.page + "&sortBy=" + this.sortBy + "&revert=" + this.revert + '&status=' + this.selectedStatus ;
    if (this.authService.connectedAs.admin == false)
      query += "&connectedAsId=" + this.authService.connectedAs.id;

    this.http.get(environment.API_PATH + '/campaign' + query, {withCredentials: true})
	  .subscribe(
      data => {
        this.isLoading = false;
        this.campaigns = data['rows'];
        this.totalPage = Math.ceil(data['count'] / this.limit) ;
      },
      err => {
        this.isLoading = false;
        var errors = err.error;
        if (errors.error) {
          if (errors.error.status === 401) {

            this.router.navigate(['/connexion']);
          } else if (errors.error.status === 403) {
            if (errors.error.details.redirect)
              this.router.navigate([errors.error.details.redirect]);
            else
              this.router.navigate(['connexion']);
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }

  changePage(num: number, n:number = null): void {
    if (n)
      this.page = this.numPipe.transform(num, n);
    else
      this.page = num;

    this.getCampaigns();
  };

  sortTable(sortBy: string): void {
    if (this.sortBy === sortBy)
      this.revert = !this.revert;
    else
      this.revert = false;
    this.sortBy = sortBy;
    this.getCampaigns();
  }

  seeTargets(campaignId) {
    this.http.get(environment.API_PATH + '/campaign/target/' + campaignId, {withCredentials: true})
	  .subscribe(
      data => {
        this.isLoading = false;
        var pharmaStr = "";
        for (let i in data['rows']) {
          if (data['rows'][i].pharmacy) {
            pharmaStr += '<tr><td class="text-left">' + data['rows'][i].pharmacy.cip + '</td><td class="text-left">' + data['rows'][i].pharmacy.name + '</td></tr>';
          }
          else {
            pharmaStr += '<tr><td class="text-left"> - </td><td class="text-left">Pharmacie supprimée</td></tr>';
          }
        }
        swal({
          title: 'Liste des pharmacies',
          html: '<div class="col-xs-12 table-responsive no-padding" style="max-height: 500px">' +
          '<table class="table table-striped primary sortable-table">' +
          '<div class="col-xs-12 table-responsive no-padding">' +
          '<table class="table table-striped primary sortable-table">' +
          '<thead>' +
          '<tr>' +
          '<th>CIP</th>' +
          '<th>Nom de la pharmacie</th>' +
          '</tr>' +
          '</thead>' +
          '<tbody>' +
          pharmaStr +
          '</tbody>' +
          '</table>',
          type: 'info',
          customClass: 'pharma-list-modal'
        }).then(() => {
        }, () => {
        });
      },
      err => {
        this.isLoading = false;
        if (err.status === 401) {

          this.router.navigate(['/connexion']);
        } else if (err.status === 404) {
          this.utilsService.displayNotif("Cette campagne n'existe pas", "danger");
          this.router.navigate(['../..'], {relativeTo: this.route});
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }

  onSearchChange(query:string) {
    this.txtQueryChanged.next(query);
  }

  confirmRemove(id: number, name: any): void {
    swal({
      title: 'Êtes-vous sûr de vouloir supprimer la campagne "' + name + '" ?',
      text: "Vous ne pourrez pas revenir en arrière",
      type: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#49B0D6',
      cancelButtonColor: '#E74C3C',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then(() => {
      this.removeCampaign(id);
    }, () => {

    });
  }

  removeCampaign(id) {
    this.isLoading = true;
    this.http.delete(environment.API_PATH + '/campaign/delete/' + id, {withCredentials: true})
	  .subscribe(
      data => {
        this.getCampaigns();
        this.isLoading = false;
      },
      err => {
        var errors = err.error;
        this.isLoading = false;
        if (errors.error) {
          if (errors.error.status === 401) {

            this.router.navigate(['/connexion']);
          } else if (errors.error.status === 403) {
            if (errors.error.details.redirect)
              this.router.navigate([errors.error.details.redirect]);
            else
              this.router.navigate(['connexion']);
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }

  recapCampaign(id) {
    this.router.navigate(['recapitulatif', id], {relativeTo: this.route});
  }

  downloadRecap(campaign) {
    this.isLoading = true;

    let dataArr = [
      ['Nom', 'CIP', 'Email', 'Adresse', 'Code postal', 'Ville', 'Pays', 'Statut de la campagne', 'Commentaire', 'Validé/Refusé par']
    ];

    var query = "";
    if (this.authService.connectedAs.admin == false)
      query += "?connectedAsId=" + this.authService.connectedAs.id;
    this.http.get(environment.API_PATH + '/campaign/archive/' + campaign.id + query, {withCredentials: true})
	  .subscribe(
      data => {
        for (let q in data['pharmacy_campaigns'][0]['campaign']['questions']) {
          dataArr[0].push(data['pharmacy_campaigns'][0]['campaign']['questions'][q]['question']);
        }
        this.isLoading = false;
        for (var i in data['pharmacy_campaigns']) {
          let camp = data['pharmacy_campaigns'][i];
          let status = camp.status === 'IN_COMING' ? 'À venir' : camp.status === 'IN_PROGRESS' ? 'En cours' : camp.status === 'NO_DATA' ? 'Pas de donnée' : camp.status === 'WAITING_APPROVEMENT' ? 'En attente de validation' : camp.status === 'REFUSED' ? 'Refusée' : camp.status === 'DONE' ? 'Clôturée' : camp.status;
          let line = [camp.pharmacy.name, camp.pharmacy.cip, camp.pharmacy.email, camp.pharmacy.address, camp.pharmacy.zipcode, camp.pharmacy.city, camp.pharmacy.country, status, (camp.pharmacy_campaign_statuses[0])? camp.pharmacy_campaign_statuses[0]['reason'] : '', (camp.pharmacy_campaign_statuses[0] && camp.pharmacy_campaign_statuses[0]['user'])? (camp.pharmacy_campaign_statuses[0]['user']['firstname'] + ' ' + camp.pharmacy_campaign_statuses[0]['user']['lastname']) : ''];
          for (let r in camp['campaign']['questions']) {
            let answer = '';
            let question = camp['campaign']['questions'][r];
            if (question['campaign_question_answers'] && question['campaign_question_answers'].length) {
              if (question['type'] === 'picture') {
                for (let s in question['campaign_question_answers']) {
                  answer += environment.SERVER_HOST + question['campaign_question_answers'][s]['answer'] + '\n';
                }
              } else {
                for (let s in question['campaign_question_answers']) {
                  answer += question['campaign_question_answers'][s]['answer'] + '\n';
                }
              }
            }
            line.push(answer);
          }
          dataArr.push(line);
        }
        const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(dataArr);

        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        const wbout: ArrayBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        let blob = new Blob([wbout], {type: 'application/octet-stream'});

        saveAs(blob, campaign.name + ".xlsx");
      },
      err => {
        this.isLoading = false;
        var errors = err.error;
        if (errors.error) {
          if (errors.error.status === 401) {

            this.router.navigate(['/connexion']);
          } else if (errors.error.status === 403) {
            if (errors.error.details.redirect)
              this.router.navigate([errors.error.details.redirect]);
            else
              this.router.navigate(['connexion']);
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      }
    )
  }

  downloadArchive(campaign) {
    this.isLoading = true;

    var query = "";
    if (this.authService.connectedAs.admin == false)
      query += "?connectedAsId=" + this.authService.connectedAs.id;

    this.http.get(environment.API_PATH + '/campaign/archive/' + campaign.id + query, {withCredentials: true})
    .subscribe(
      data => {
        this.isLoading = false;
        var zip = new JSZip();
        var pharmaContent = "";
        for (var i in data['pharmacy_campaigns']) {
          pharmaContent += data['pharmacy_campaigns'][i].pharmacy.cip + '-' + data['pharmacy_campaigns'][i].pharmacy.name + '\n';
          var folder = zip.folder(data['pharmacy_campaigns'][i].pharmacy.cip + '-' + data['pharmacy_campaigns'][i].pharmacy.name);
          var content = "";
          for (var j in data['pharmacy_campaigns'][i].campaign.questions) {
            content += data['pharmacy_campaigns'][i].campaign.questions[j].question + " : \n";
            if (data['pharmacy_campaigns'][i].campaign.questions[j].campaign_question_answers.length == 0)
              content += "\t * Pas de réponses\n";
            else {
              for (var k in data['pharmacy_campaigns'][i].campaign.questions[j].campaign_question_answers) {
                if (data['pharmacy_campaigns'][i].campaign.questions[j].type !== 'picture') {
                  content += "\t * " + data['pharmacy_campaigns'][i].campaign.questions[j].campaign_question_answers[k].answer + '\n';
                }
                else {
                  var url = data['pharmacy_campaigns'][i].campaign.questions[j].campaign_question_answers[k].answer;
                  var split = url.split('/');
                  if (split.length) {
                    var fileName = split[split.length - 1];
                    content += "\t * cf : " + fileName;
                    var self = this;
                    var promise = new Promise(function (resolve, reject) {
                      self.http.get(environment.SERVER_HOST + url, {responseType: "blob"})
                      .subscribe(data => {
                        resolve(data);
                      }, err => {
                        reject(err);
                      });
                    });
                    folder.file(fileName, promise);
                  }
                }
              }
            }
            content += '\n';
          }
          folder.file('reponses.txt', content);
        }
        zip.file('liste-pharmacies.txt', pharmaContent);


        zip.generateAsync({type:"blob"})
        .then(function (blob) {
          saveAs(blob, campaign.name + ".zip");
        });
      },
      err => {
        this.isLoading = false;
        var errors = err.error;
        if (errors.error) {
          if (errors.error.status === 401) {

            this.router.navigate(['/connexion']);
          } else if (errors.error.status === 403) {
            if (errors.error.details.redirect)
              this.router.navigate([errors.error.details.redirect]);
            else
              this.router.navigate(['connexion']);
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      }
    )

  }

}



// WEBPACK FOOTER //
// ./src/app/list-campaign/list-campaign.component.ts